import styles from './SingleAssetPanel.module.scss';
import { useAppSelector } from '@customer/store/hooks';
import { useTranslation } from 'react-i18next';
import { ConnectivitySnackbar } from '@dmc/ui';
import { useGetSingleAssetsQuery } from '@customer/store/apis/assetsApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { VdsButton } from '@volt/volt-extended-components-react';
import { DrawerPanel } from '@dmc/ui';
import { useAssetGroupChips } from '@customer/hooks/assets/useAssetGroupChips';
import AssetIdentifier from '@customer/components/asset-data/asset-identifier/AssetIdentifier';
import Tabs from '@cas/components/tabs/tabs/Tabs';
import useSingleAssetPanelNavigation from './useSingleAssetPanelNavigation';

export function SingleAssetPanel() {
  const { t } = useTranslation();

  const globalState = useAppSelector(state => state.global);

  const { currentData: asset, error: fetchError } = useGetSingleAssetsQuery(
    globalState.sidePanelModelId ?? skipToken,
    { refetchOnMountOrArgChange: 10 },
  );

  const vehicleGroupChips = useAssetGroupChips({ assetGroups: asset?.ags });

  const { tabsProps, activeView, btnProps } = useSingleAssetPanelNavigation(asset);

  return (
    <>
      <DrawerPanel
        header={
          <div className={styles.header}>
            <AssetIdentifier
              name={asset?.name}
              mismatch={asset?.stsNam === false}
              deviceType={asset?.hw ?? '0'}
            />
            <div className={styles.header__asset_type}>{vehicleGroupChips}</div>
          </div>
        }
        tabs={asset && <Tabs {...tabsProps} hasBorder />}
        footer={
          asset &&
          btnProps && <VdsButton {...btnProps} variant="primary" size="medium" isFullWidth />
        }
      >
        {asset && activeView}
      </DrawerPanel>

      <ConnectivitySnackbar error={fetchError} message={t('FetchAssetError')} title={t('Error')} />
    </>
  );
}

export default SingleAssetPanel;
